import React from "react";
import i18n from '../../../../utils/ChrI18n';
import ResponsesWidget from "./ResponsesWidget";

const InAWordResponsesContainer = ({preMeetingResponsesData, postMeetingResponsesData}) => {
  return (
    <div className="cui-in-a-word-responses-container">
      <div className="cui-widget-item">
        <ResponsesWidget 
          headerText={i18n.t("widgets.in_a_word_responses.before_meetings", jsConstants.customTerms)} 
          totalResponsesCount={preMeetingResponsesData?.responses_count} 
          topWordsData={preMeetingResponsesData?.response_values}
          colorScale={["#007CB4", "#003A5A"]}
          wordCloudId={"pre-meeting-word-cloud-container"}
        />
      </div>
      
      <div className="cui-widget-separator"></div>
      
      <div className="cui-widget-item">
        <ResponsesWidget 
            headerText={i18n.t("widgets.in_a_word_responses.after_meetings", jsConstants.customTerms)} 
            totalResponsesCount={postMeetingResponsesData?.responses_count} 
            topWordsData={postMeetingResponsesData?.response_values} 
            colorScale={["#8051FF", "#1C004F"]}
            wordCloudId={"post-meeting-word-cloud-container"}
        />
      </div>
    </div>
  );
}

export default InAWordResponsesContainer;